/* ============================================================
   CANO — predictive search (renders the predictive-search section)
   ============================================================ */
(function () {
  "use strict";

  var drawer = document.querySelector(".search-drawer");
  if (!drawer) return;

  var input = drawer.querySelector('input[type="search"]');
  var results = drawer.querySelector(".search-results");
  if (!input || !results) return;

  var base = (window.CANO && window.CANO.routes && window.CANO.routes.predictive_search_url) || "/search/suggest";
  var idle = '<p class="meta">Type to search the store.</p>';
  var t, lastQ = "", controller;

  function run(q) {
    if (q.length < 2) { results.innerHTML = idle; return; }
    results.innerHTML = '<p class="psearch__loading">Searching&hellip;</p>';
    if (controller) controller.abort();
    controller = new AbortController();
    var url = base + "?q=" + encodeURIComponent(q) +
      "&resources[type]=product,collection,page,article" +
      "&resources[limit]=6&section_id=predictive-search";
    fetch(url, { signal: controller.signal, headers: { "Accept": "text/html" } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var content = doc.querySelector(".psearch");
        results.innerHTML = content ? content.outerHTML : '<p class="psearch__empty">No results.</p>';
      })
      .catch(function (e) { if (e.name !== "AbortError") results.innerHTML = idle; });
  }

  input.addEventListener("input", function () {
    var q = input.value.trim();
    if (q === lastQ) return;
    lastQ = q;
    clearTimeout(t);
    t = setTimeout(function () { run(q); }, 220);
  });

  // reset when the drawer closes
  document.querySelectorAll("[data-search-close]").forEach(function (b) {
    b.addEventListener("click", function () { input.value = ""; lastQ = ""; results.innerHTML = idle; });
  });
})();
